export const PERSISTED_STATE_KEY = `persisted`;

export type StepProps = {
  header: string;
  body: string;
  label: string | number;
  completed?: boolean;
  onClick: () => void;
};

export enum ChecklistStep {
  OrgSetup = `OrgSetup`,
  Implementation = `Implementation`,
  ViewEvent = `ViewEvent`,
  CreateBoard = `CreateBoard`,
}

export type OnboardingChecklistState = {
  expanded: boolean;
  status: {[key in ChecklistStep]: boolean};
  showCelebrationPeek: boolean;
  copiedLink: boolean;
  showSurvey: boolean;
};

export type OnboardingChecklistParams = {
  shouldCollapse: boolean;
  viewingBoards: boolean;
  inviteCallback: () => void;
  dismissCallback: () => void;
  completeCallback: () => void;
  userEmail: string;
};

export type OnboardingChecklistJsxProps = {
  params?: OnboardingChecklistParams;
};

export type StepMetadata = {
  readonly requireImplementation: boolean;
  title: string;
  description: string;
  callback?: (args: {completed?: boolean; orgId?: number}) => void;
  statusUpdate?: Partial<{[key in ChecklistStep]: boolean}>;
  trackingEventName: OnboardingChecklistTrackingEvent;
};

export enum OnboardingChecklistTrackingEvent {
  Dismiss = `[OnboardingChecklist] Click Dismiss`,
  Finish = `[OnboardingChecklist] Click Finish`,
  Completed = `[OnboardingChecklist] Completed`,
  CopyUrl = `[OnboardingChecklist] Celebration: Copied Url`,
  Invite = `[OnboardingChecklist] Celebration: Invite teammate`,
  Calendly = `[OnboardingChecklist] Click Calendly Link`,

  // Steps
  OrgSetup = `[OnboardingChecklist] Click Org Setup`,
  Implementation = `[OnboardingChecklist] Click Implementation`,
  ViewEvent = `[OnboardingChecklist] Click View Event`,
  CreateBoard = `[OnboardingChecklist] Click Create Board`,
}

export const CALENDLY_URL = `https://calendly.com/d/4d5-5b6-57p/onboarding-call`;
